
import { Link } from "react-router-dom";

export default function PrimaryButton({
  to,
  children,
  className = '',
}) {
  return (
    <Link to={to} className={`inline-flex items-center justify-center rounded-[10px] bg-cyan-400 px-3 py-2 text-[14.2px] font-medium text-black transition-all duration-300 hover:scale-105 hover:shadow-lg ${className}`}>
      {children}
    </Link>
  );
}